export default {
    path: "/personalization",
    name: "personalization",
    children: [
        {
            path: "1",
            name: "step1",
            component: () => import('@/views/Personalization/Step1.vue')
        },
        {
            path: "2",
            name: "step2",
            component: () => import('@/views/Personalization/Step2.vue')
        },
        {
            path: "3",
            name: "step3",
            component: () => import('@/views/Personalization/Step3.vue')
        },
        {
            path: "4",
            name: "step4",
            component: () => import('@/views/Personalization/Step4.vue')
        },
        {
            path: "5",
            name: "step5",
            component: () => import('@/views/Personalization/Step5.vue')
        },
        {
            path: "6",
            name: "step6",
            component: () => import('@/views/Personalization/Step6.vue')
        },
        {
            path: "finish",
            name: "finish",
            component: () => import('@/views/Personalization/Finish.vue')
        },
        {
            path: "created",
            name: "created",
            component: () => import('@/views/Personalization/Created.vue')
        }
    ]
}
